export function upsellPopupsReducer(state = {
  upsell_popups: [],
  productList: {},
  fetching: false,
  fetched: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'GET_UPSELL_POPUP_LIST_REJECTED':
    case 'GET_UPSELL_POPUP_LIST_PENDING':
    case 'GET_UPSELL_POPUP_PENDING': {
      return {...state, fetching: true, fetched: false}
    }
    case 'GET_UPSELL_POPUPS_FOR_NEW_ORDER_PAGE_REJECTED':
    case 'GET_UPSELL_POPUPS_FOR_NEW_ORDER_PAGE_PENDING':
    case 'GET_UPSELL_POPUPS_FOR_NEW_ORDER_PAGE_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        upsell_popups: action.payLoad.data,
      }
    }
    case 'GET_UPSELL_POPUP_LIST_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        upsell_popups: action.payLoad.data,
        productList: action.payLoad.meta.products,
      }
    }
    case 'CLEAR_UPSELL_POPUPS': {
      return {
        ...state,
        upsell_popup: [],
      }
    }
    case 'GET_UPSELL_POPUP_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        upsell_popup: action.payLoad,
        saved: false,
      }
    }
    case 'GET_UPSELL_POPUP_REJECTED': {
      return {...state, errors: action.payLoad.errors}
    }

  }
  return {...state};
}



// WEBPACK FOOTER //
// ./src/reducers/upsellPopupsReducer.js